/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConnectivityStatusDto
 */
export interface ConnectivityStatusDto {
    /**
     *
     * @type {Date}
     * @memberof ConnectivityStatusDto
     */
    date?: Date;
    /**
     *
     * @type {string}
     * @memberof ConnectivityStatusDto
     */
    status?: ConnectivityStatusDtoStatusEnum;
}

/**
 * @export
 */
export const ConnectivityStatusDtoStatusEnum = {
    Online: "Online",
    Offline: "Offline",
} as const;
export type ConnectivityStatusDtoStatusEnum =
    (typeof ConnectivityStatusDtoStatusEnum)[keyof typeof ConnectivityStatusDtoStatusEnum];

/**
 * Check if a given object implements the ConnectivityStatusDto interface.
 */
export function instanceOfConnectivityStatusDto(
    value: object,
): value is ConnectivityStatusDto {
    return true;
}

export function ConnectivityStatusDtoFromJSON(
    json: any,
): ConnectivityStatusDto {
    return ConnectivityStatusDtoFromJSONTyped(json, false);
}

export function ConnectivityStatusDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectivityStatusDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function ConnectivityStatusDtoToJSON(
    value?: ConnectivityStatusDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        status: value["status"],
    };
}
